import { render } from "./KeywordRegisterModal.vue?vue&type=template&id=6b143f82&scoped=true"
import script from "./KeywordRegisterModal.vue?vue&type=script&lang=js"
export * from "./KeywordRegisterModal.vue?vue&type=script&lang=js"

import "./KeywordRegisterModal.vue?vue&type=style&index=0&id=6b143f82&lang=scss&scoped=true"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-6b143f82"]])

export default __exports__